import { Trascodifica } from "./trascodifica";

export class RichiestaMutuoNote {
    id: number;
    dataCreazione: Date;
    note: string;
    stato: Trascodifica;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo-note.ts